module.exports = __webpack_public_path__ + "img/101-el-02.prt.14641efb.jpg";